<template>
  <div style="display: flex; align-items: center">
    <input
      data-test="single-input"
      :type="inputTypeValue"
      :inputmode="inputmode"
      :placeholder="placeholder"
      :disabled="isDisabled"
      ref="input"
      min="0"
      max="9"
      :maxlength="isFirstChild ? totalInputs : 1"
      pattern="[0-9]"
      v-model="model"
      :class="[inputClasses, conditionalClass, { 'is-complete': model }]"
      @input="handleOnChange"
      @keydown="handleOnKeyDown"
      @paste="handleOnPaste"
      @focus="handleOnFocus"
      @blur="handleOnBlur"
    />
    <span v-if="!isLastChild && separator">
      <span v-html="separator"></span>
    </span>
  </div>
</template>

<script>
export default {
  name: "SingleOtpInput",
  props: {
    inputType: {
      type: String,
      default: "tel",
    },
    inputmode: {
      type: String,
      default: "numeric",
    },
    value: {
      type: String,
      required: true,
    },
    separator: {
      type: String,
      default: "",
    },
    focus: {
      type: Boolean,
      default: false,
    },
    inputClasses: {
      type: [String, Array],
      default: "",
    },
    conditionalClass: {
      type: String,
      default: "",
    },
    shouldAutoFocus: {
      type: Boolean,
      default: false,
    },
    isFirstChild: {
      type: Boolean,
      default: false,
    },
    isLastChild: {
      type: Boolean,
      default: false,
    },
    totalInputs: {
      type: Number,
      default: 4,
    },
    placeholder: {
      type: String,
      default: "",
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.value,
    };
  },
  computed: {
    inputTypeValue() {
      return ["letter-numeric", "number"].includes(this.inputType)
        ? this.inputType
        : "text";
    },
  },
  watch: {
    value(newValue) {
      this.model = newValue;
    },
    focus(newFocusValue, oldFocusValue) {
      if (
        oldFocusValue !== newFocusValue &&
        this.$refs.input &&
        newFocusValue
      ) {
        this.$refs.input.focus();
        this.$refs.input.select();
      }
    },
  },
  methods: {
    handleOnChange(e) {
      if (!this.isFirstChild && this.model && this.model.length > 1) {
        this.model = this.value || this.model[0];
        e.target.value = this.model;
      }
      this.$emit("on-change", this.model);
    },
    isCodeLetter(charCode) {
      return charCode >= 65 && charCode <= 90;
    },
    isCodeNumeric(charCode) {
      return (
        (charCode >= 48 && charCode <= 57) ||
        (charCode >= 96 && charCode <= 105)
      );
    },
    handleOnKeyDown(event) {
      if (this.isDisabled) {
        event.preventDefault();
        return;
      }

      const keyCode = event.keyCode || event.which;
      const allowedKeys = [8, 9, 13, 37, 39, 46, 86]; // Allow Backspace, Tab, Enter, Arrows, Delete, Paste (Ctrl + V)

      const isDigitKey =
        this.isCodeNumeric(keyCode) ||
        (this.inputType === "letter-numeric" && this.isCodeLetter(keyCode));

      if (this.isLastChild && this.model && isDigitKey) {
        event.preventDefault();
        return;
      }

      if (isDigitKey || allowedKeys.includes(keyCode)) {
        this.$emit("on-keydown", event);
      } else {
        event.preventDefault();
      }
    },
    handleOnPaste(event) {
      this.$emit("on-paste", event);
    },
    handleOnFocus() {
      this.$refs.input?.select();
      this.$emit("on-focus");
    },
    handleOnBlur() {
      this.$emit("on-blur");
    },
  },
  mounted() {
    if (this.$refs.input && this.focus && this.shouldAutoFocus) {
      this.$refs.input.focus();
      this.$refs.input.select();
    }
  },
};
</script>
